import { CODE_LANGUAGE_FRIENDLY_NAME_MAP } from '@lexical/code'


export function dropDownActiveClass(active: boolean) {
   if (active) return 'active dropdown-item-active';
   else return '';
}

export function getCodeLanguageOptions(): [string, string][] {
   const options: [string, string][] = [];

   for (const [lang, friendlyName] of Object.entries(
      CODE_LANGUAGE_FRIENDLY_NAME_MAP,
   )) {
      options.push([lang, friendlyName as string]);
   }

   return options;
}